/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AgencyConfiguration,
    AgencyConfigurationFromJSON,
    AgencyConfigurationToJSON,
    AgencyListQuery,
    AgencyListQueryFromJSON,
    AgencyListQueryToJSON,
    AgencyListResponse,
    AgencyListResponseFromJSON,
    AgencyListResponseToJSON,
} from '../models';

export interface ApiAgencyListDataPostRequest {
    agencyListQuery?: AgencyListQuery;
}

/**
 * no description
 */
export class AgencyListApi extends runtime.BaseAPI {

    /**
     */
    async apiAgencyListConfigurationGetRaw(): Promise<runtime.ApiResponse<AgencyConfiguration>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyList/Configuration`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyConfigurationFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyListConfigurationGet(): Promise<AgencyConfiguration> {
        const response = await this.apiAgencyListConfigurationGetRaw();
        return await response.value();
    }

    /**
     */
    async apiAgencyListDataPostRaw(requestParameters: ApiAgencyListDataPostRequest): Promise<runtime.ApiResponse<AgencyListResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/AgencyList/Data`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AgencyListQueryToJSON(requestParameters.agencyListQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => AgencyListResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAgencyListDataPost(requestParameters: ApiAgencyListDataPostRequest): Promise<AgencyListResponse> {
        const response = await this.apiAgencyListDataPostRaw(requestParameters);
        return await response.value();
    }

}
